/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Issue_No_Credit_NoteInputs */

const en_inbound_issue_no_credit_note = /** @type {(inputs: Inbound_Issue_No_Credit_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a file goes only with a credit note`)
};

/**
* | output |
* | --- |
* | "a file goes only with a credit note" |
*
* @param {Inbound_Issue_No_Credit_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_issue_no_credit_note = /** @type {((inputs?: Inbound_Issue_No_Credit_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Issue_No_Credit_NoteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_issue_no_credit_note(inputs)
});